<template>
  <el-row>
    <el-tabs v-model="activeName"
             type="card"
             @tab-click="handleClick">
      <el-tab-pane label="水表"
                   name="1"></el-tab-pane>
      <el-tab-pane label="电表"
                   name="2"></el-tab-pane>
    </el-tabs>
    <el-card shadow="none"
             class="form-card mb-15">
      <el-form :inline="true"
               :model="searchForm"
               ref="search_form"
               class="search-form">
        <el-form-item label="房间:"
                      prop="room_name">
          <el-input v-model.trim="searchForm.room_name"
                    placeholder="房间"></el-input>
        </el-form-item>
        <el-form-item label="所属区域:"
                      prop="area_id">
          <el-select v-model="searchForm.area_id"
                     placeholder="请选择所属区域">
            <el-option v-for="item in areaList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="抄表时间:">
          <el-date-picker v-model="searchForm.time"
                          value-format="yyyy-MM-dd"
                          type="daterange"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="searchSubmit('search_form')">查询
          </el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetForm('search_form')">重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-row>
      <el-button v-has="'/meter_read/add'"
                 v-if="activeName === '1'"
                 type="primary"
                 @click="openMeterReadAdd">抄水表</el-button>
      <el-button v-has="'/meter_read/add'"
                 v-if="activeName === '2'"
                 type="primary"
                 @click="openMeterReadAdd">抄电表</el-button>
    </el-row>
    <!--
    <el-row>
      <el-button v-has="'/meter_read/export'"
                 type="primary"
                 @click="handleExport">导 出</el-button>
    </el-row>
    -->
    <el-card shadow="none"
             class="mt-15">
      <el-table max-height="575"
                ref="multipleTable"
                :data="tableData">
        <el-table-column type="index"
                         label="序号"
                         width="60"></el-table-column>
        <el-table-column v-for="(item, index) in tableTitle"
                         :key="index"
                         :label="item.name"
                         :prop="item.prop"
                         :min-width="item.width"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="100">
          <template slot-scope="scope">
            <el-button v-has="'/meter_read/edit'"
                       size="mini"
                       type="primary"
                       @click="handleEdit(scope.row)">修改</el-button>
          </template>
        </el-table-column>

      </el-table>
      <Pagination :total="pagination.total"
                  :pageSize="pagination.perPage"
                  @handleSizeChange="handleSizeChange"
                  @handleCurrent="handleCurrentChange"></Pagination>
    </el-card>
    <MeterReadAdd v-if="showReadAdd"
                  :isShow="showReadAdd"
                  :popType="popType"
                  :editData="editData"
                  :areaList="areaList"
                  :meterType="activeName"
                  @handleClose="closeMeterReadAdd">
    </MeterReadAdd>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
import utils from '@/common/utils'
import Pagination from '@/components/pagination/Pagination'
import MeterReadAdd from '@/views/business/meterRead/MeterReadAdd'
export default {
  components: { Pagination, MeterReadAdd },
  data() {
    return {
      activeName: '1',
      areaList: [],
      tmpArr: [],
      searchForm: {
        room_name: '',
        area_id: '',
        time: []
      },
      tableTitle: [
        {
          prop: 'area_name',
          name: '区域',
          width: '160'
        },
        {
          prop: 'room_name',
          name: '房间名称',
          width: '100'
        },
        {
          prop: 'meter_value',
          name: '抄表数据',
          width: '100'
        },
        {
          prop: 'read_dt',
          name: '抄表时间',
          width: '160'
        },
        {
          prop: 'reader',
          name: '抄表人',
          width: '120'
        },
        {
          prop: 'remark',
          name: '备注',
          width: '120'
        }
      ],
      // 新增抄表
      showReadAdd: false,
      popType: 'add',
      tableData: [],
      editData: {},
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      }
    }
  },
  created() {
    this.getList()
    this.getAreaTree()
  },
  methods: {
    // 获取列表
    getList() {
      const { perPage, currentPage } = this.pagination
      const sf = this.searchForm
      let datas = {
        room_name: sf.room_name,
        area_id: sf.area_id,
        startTime: sf.time.length ? sf.time[0] : '',
        endTime: sf.time.length ? sf.time[1] : ''
      }
      fetch
        .getMeterReadList({
          type: this.activeName,
          perPage: perPage,
          currentPage: currentPage,
          ...datas
        })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.pagination.total = Number(data.total)
              this.tableData = data.list
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },

    // 获取数据
    getAreaTree() {
      fetch.getAreaTree({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.tmpArr = []
            this.areaList = this.titleFormat(data.treeData, '• ')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    //  格式化名称
    titleFormat(data, prefix) {
      if (data.length === 0) {
        return []
      }
      data.forEach((item) => {
        let tmp = item
        tmp.name = prefix + item.name
        this.tmpArr.push(tmp)
        if (item.children && item.children.length > 0) {
          this.titleFormat(item.children, '• ' + prefix)
        }
      })
      return this.tmpArr
    },
    handleClick() {
      this.getList()
    },
    // 搜索提交
    searchSubmit() {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.getList()
    },
    resetForm(formName) {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.searchForm.time = []
      this.$refs[formName].resetFields()
      this.getList()
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    // 抄表
    openMeterReadAdd() {
      this.popType = 'add'
      this.showReadAdd = true
    },
    // 关闭抄表
    closeMeterReadAdd(type) {
      if (type === 'refresh') {
        this.getList()
      }
      this.showReadAdd = false
    },
    // 编辑
    handleEdit(data) {
      this.popType = 'edit'
      this.showReadAdd = true
      this.editData = data
    },
    // 导出
    handleExport() {
      const sf = this.searchForm
      let datas = {
        type: this.activeName,
        room_name: sf.room_name,
        area_id: sf.area_id,
        startTime: sf.time.length ? sf.time[0] : '',
        endTime: sf.time.length ? sf.time[1] : ''
      }
      fetch
        .exportMeterRead(
          {
            ...datas
          },
          { responseType: 'blob' }
        )
        .then((data) => {
          var blob = new Blob([data.res])
          let date = utils.format(new Date().getTime(), 'yyyy-MM-dd')
          let filename = '抄表记录-' + this.activeName === '1' ? '水表' : '电表' + date + '.xls'
          var aEle = document.createElement('a')
          let url = URL.createObjectURL(blob)
          aEle.href = url
          aEle.download = filename
          aEle.click()
          window.URL.revokeObjectURL(url)
        })
    }
  }
}
</script>

<style lang="less">
</style>
